export default "__VITE_ASSET__C1oM8HWn__"